import React, { Component } from "react";
import _ from "lodash";
import cx from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  createStyles,
  WithStyles,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  Grid,
  FormControlLabel,
  Checkbox,
  Button,
  Divider,
  Card,
  CardContent,
  CardActions,
  Chip,
  ExpansionPanelDetails,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";


// import PerfectScrollbar from 'perfect-scrollbar';
import PerfectScrollbar from "react-perfect-scrollbar";
import { ChildProps } from "../../common/MyPATLandingContainer";
import classNames from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      "&$expanded": {
        minHeight: 64,
        margin: 0,
      },
    },
    checkBoxElement: {
      padding: "0px 7px",
      top: 0,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 2,
      margin: "-4px 14px 0px 4px",
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
    }
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea",
      border: "1px solid #1d7dea !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    heightMD: {
      height: 332,
    },
    paddingMD: {
      padding: "0px 0px 20px",
    },
    clearBtn: {
      fontSize: 16,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      color: "#1D7DEA",
      background: "#FFFFFF",
      border: "1px solid #1D7DEA",
      borderRadius: 4,
      boxShadow: "none",
    },
    applyBtn: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "20px",
      textAlign: "center",
      color: "#FFFFFF",
      background: "#1D7DEA",
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.224892)",
      borderRadius: 4,
    },
    expansionPanelSummaryExpanded: {
      margin: "0 !important",
      padding: "12px 4px 12px 12px !important",
      minHeight: "21px !important",
      height: 46,
      right: 0,
    },
    filtersBox: {
      marginBottom: 0,
    },
    filterHeading: {
      fontWeight: 600,
      fontSize: 20,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      color: "rgba(51, 51, 51, 0.87)",
      fontFamily: "Nunito",
      textTransform: "uppercase",
    },
    expansionPanelExpanded: {
      margin: "2px 0px",
    },

    expansionPanelRoot: {
      "&:first-child": {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        width: "99.58%",
      },
      "&:before": {
        opacity: 0.3,
      },
    },
    expansionPanelSummaryRoot: {
      padding: "0px 18px",
      minHeight: "auto !important",
      "&:before": {
        opacity: 0.2,
      },
    },
    smallFont: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 12,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      color: "#666666",
    },
    textStyleSM: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: 16,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      color: "#333333",
    },
    expansionPanelRounded: {
      "& :before": {
        display: "none",
      },
    },
    expansionPanelSummaryContent: {
      margin: "0 !important",
      display: "flex",
      justifyContent: "space-between",
      "& :last-child": {
        fontSize: 14,
        lineHeight: "24px",
        display: "flex",
        alignItems: "center",
        color: "rgb(51 51 51 / 87%)",
      },
      "& p": {
        fontWeight: 600,
      },
    },
    GridRoot: {
      flexDirection: "column",
      padding: 0,
      paddingLeft: theme.spacing.unit * 2,
    },

    formControlLabelRoot: {
      margin: 0,
      paddingRight: "0 !important",
      padding: theme.spacing.unit,
      width: "100%",
      "& span": {
        fontWeight: 500,
      },
    },
    checkboxRoot: {
      padding: 0,
      marginRight: theme.spacing.unit,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      margin: "14px 16px",
      borderRadius: 2,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
    },

    addFilterWrapper: {
      textAlign: "center",
      margin: `${theme.spacing.unit}px 0`,
      "& a": {
        cursor: "pointer",
        display: "inline-block",
        "&:hover": {
          textDecoration: "none",
        },
      },
    },

    listItemRoot: {
      padding: 0,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[300]}`,
      borderTopWidth: 0,
      "&:first-child": {
        borderTopWidth: 1,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
      },
      "&:last-child": {
        borderBottomLeftRadius: 3,
        borderBottomRightRadius: 3,
      },
      "&:hover": {
        backgroundColor: theme.palette.common.white,
      },
    },

    filterStickyTop: {
      position: "sticky",
      top: 64,
    },
    filterStickyBottom: {
      position: "absolute",
      width: "100%",
      bottom: 0,
      left: 0,
    },
    sidePanelWrapper: {
      transition: "top 0.25s ease",
      willChange: "min-height",
      padding: 0,
      "& #filterWrapper": {
        transform: `translate(0, 0) translate3d(0,0,0)`,
        willChange: "position, transform",
      },
    },
    bottomZero: {
      bottom: 10,
      display: "flex",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: 600,
      background: "#ffffff",
      width: 300,
      padding: 17,
      border: "solid 1px #e6e6e6",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none",
      },
    },
    stickyFilter: {
      position: "sticky",
    },
    absoluteFilter: {
      position: "absolute",
    },
    fixedFilter: {
      position: "fixed",
    },
    relativeFilter: {
      position: "relative",
    },
    filterClass: {
      maxHeight: "430px",
    },
    drawerBody: {
      padding: theme.spacing.unit,
    },

    label: { border: "1px solid #DFDFDF", marginLeft: 0, marginRight: 0 },

    suggestContainer: {
      position: "relative",
    },
    searchRoot: {
      padding: theme.spacing.unit / 4,
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
      border: "1px solid #DFDFDF",
      width: "100%",
    },
    suggestList: {
      fontFamily: `'Roboto', 'sans-serif'`,
      position: "absolute",
      top: "38px",
      left: "0",
      background: "#fff",
      boxShadow: "0px 0px 2px #ccc",
      padding: 0,
      zIndex: 10,
      listStyleType: "none",
      marginTop: 0,
      width: "100%",
      maxHeight: "150px",
      overflowY: "scroll",
    },
    suggestItem: {
      padding: theme.spacing.unit,
      paddingBottom: theme.spacing.unit + 4,
      cursor: "pointer",
      zIndex: 11,
      "&::after": {
        content: "",
        display: "table",
        clear: "both",
      },
    },

    /* modal design transfer */
    paddingSm: {
      padding: "10px 20px",
    },
    filterList: {
      height: "63vh",
      width: 298,
    },
    categoryCardContent: {
      minHeight: 377,
      height: 100,
      padding: "0px 16px 16px 16px",
    },
    marginTop2x: {
      marginTop: 6,
    },
    tableView: {
      display: "table",
    },
    mainDialogContainer: {
      color: "#333333",
      fontWeight: 600,
      marginBottom: 10,
      marginTop: 10,
    },
    filterLabel: {
      minWidth: 132,
      padding: "-8px 0px",
      float: "left",
    },
    categoryCardAction: {
      justifyContent: "flex-end",
      padding: 10,
    },

    /* appplied filters design transfer */
    padding0x: {
      padding: "0px !important",
    },
    filterListBlock: {
      maxHeight: 566,
      "& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y": {
        width: 10,
        backgroundColor: "#eee",
      },
      "& .ps__thumb-y, .ps__rail-y:hover > .ps__thumb-y": {
        backgroundColor: "#999",
        width: 6,
      },
    },
    modalHeader: {
      minHeight: 46,
      padding: "8px 20px 20px",
    },
    scrollbarContainer: {
      "& .ps__rail-x:hover > .ps__thumb-x, .ps__rail-x:hover, .ps__rail-x": {
        height: 6,
      },
      "& .ps__thumb-x": {
        height: 6,
        bottom: 0,
      },
      "& .ps__rail-y": {
        display: "none",
      },
    },
    modalFilterChip: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      fontSize: 20,
      lineHeight: "24px",
      alignItems: "center",
      color: "#666666",
      fontStyle: "normal",
      fontWeight: "normal",
      margin: "14px 0px 20px",
      maxHeight: 60,
      textAlign: "left",
      fontFamily: "'Nunito/', sans-serif",
      "& > div": {
        display: "flex",
      },
    },
    filterChip: {
      whiteSpace: "nowrap",
      borderRadius: 16,
      verticalAlign: "middle",
      justifyContent: "center",
      textDecoration: "none",
      backgroundColor: "#e0e0e0",
      margin: "8px 12px 10px 4px",
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 16,
      lineHeight: "20px",
      alignItems: "center",
    },
    greyTextColor: {
      color: "rgba(0, 0, 0, 0.543846)",
    },
    filterTitle: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 14,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      color: "#333333 !important",
      textTransform: "uppercase",
    },
    clearAllBtn: {
      background: "none!important",
      border: "none",
      padding: "0!important",
      /*optional*/
      fontFamily: "arial, sans-serif",
      /*input has OS specific font-family*/
      color: "rgba(0, 0, 0, 0.543846)",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    btn0: {
      position: "absolute",
      bottom: 0,
    },
    expansionPanelDetails: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "200px",
      overflow: "auto",
      padding: 0,
    },
    activeFilter: {
      color: "#1D7DEA",
    },
    subFilter: {
      cursor: "pointer",
      margin: "10px 0",
      padding: "5px 24px",
      fontWeight: 600,
      fontSize: "14px",
    },
    subFilterHeading: {
      fontSize: "20px",
      margin: "20px 0",
    },
    emptyFilterText: {
      color: "#999",
      fontSize: "12px",
    },
    noContentContainer: {
      textAlign: "center",
      "& img": {
        width: "40%",
      },
    },
  });

//@ts-ignore
interface ContentFilterProps extends WithStyles<typeof styles> {
  filters: ChildProps["filters"];
  handleFilterChange: ChildProps["handleFilterChange"];
  onClose: () => void;
}

enum FilterKeys {
  "year" = "year",
  "courseType" = "courseType",
  "classes" = "classes",
  "status" = "status",
}
interface ContentFilterStates {
  filters: { [filterKey in FilterKeys]: { name: string; values: string[] } };
  currentlyActiveFilter: FilterKeys | "";
}

const EMPTY_FILTER_STATE = {
  year: { name: "Target Year", values: [] },
  courseType: { name: "Target Exam", values: [] },
  classes: { name: "Classes", values: [] },
  status: { name: "Status", values: [] },
};

class ContentFilter extends Component<ContentFilterProps, ContentFilterStates> {
  filterCreateTimer: any;
  // initialContentFilterData: any;
  constructor(props: ContentFilterProps) {
    super(props);

    this.state = {
      filters: EMPTY_FILTER_STATE,
      currentlyActiveFilter: "",
    };
  }

  componentDidMount() {
    const { filters } = this.props;
    const filterKeys: string[] = Object.values(FilterKeys);
    const newLocalFilters = Object.entries(filters).reduce(
      (
        acc: { [key in FilterKeys]: { name: string; values: string[] } },
        [filterKey, { values }]
      ) => {
        if (filterKeys.includes(filterKey)) {
          // @ts-ignore
          acc[filterKey] = { name: acc[filterKey].name, values };
        }
        return acc;
      },
      { ...EMPTY_FILTER_STATE }
    );
    this.setState({ filters: newLocalFilters });
  }

  applyLocalFilter = (filterKey: FilterKeys, value: string) => {
    this.setState((prevState) => {
      const newFilters = { ...prevState.filters };
      let newFilterValue = [...newFilters[filterKey].values];
      const foundIndex = newFilterValue.findIndex((val) => val === value);

      if (foundIndex > -1) {
        newFilterValue.splice(foundIndex, 1);
      } else {
        newFilterValue.push(value);
      }
      newFilters[filterKey] = {
        ...newFilters[filterKey],
        values: newFilterValue,
      };

      return {
        ...prevState,
        filters: newFilters,
      };
    });
  };

  setFilterAsActive = (filterKey: FilterKeys) => () => {
    this.setState({ currentlyActiveFilter: filterKey });
  };

  onApply = () => {
    const { filters } = this.state;
    const { handleFilterChange, onClose } = this.props;
    Object.entries(filters).forEach(([filterKey, { values }]) => {
      handleFilterChange(filterKey, values, true);
    });
    onClose();
  };

  onReset = () => {
    this.setState({ filters: EMPTY_FILTER_STATE });
  };

  clearTargetExam = () => {
    this.setState((prevState) => {
      const newFilters = { ...prevState.filters };
      const newCourseTypeValues: string[] = [];
      const newCourseTypeFilter = { ...newFilters.courseType };
      newCourseTypeFilter.values = newCourseTypeValues;
      newFilters.courseType = newCourseTypeFilter;

      return {
        ...prevState,
        filters: newFilters,
      };
    });
  };

  renderFilterChip(showEmptyFilter: boolean = false) {
    const { classes, filters } = this.props;
    const { filters: localFilters } = this.state;

    const allFiltersEmpty = Object.entries(localFilters).reduce(
      (acc, [filterKey, { values }]) => acc && values.length === 0,
      true
    );

    if (allFiltersEmpty) {
      return (
        <Typography variant="subheading" className={classes.emptyFilterText}>
          No filters applied yet, apply filters from below
        </Typography>
      );
    }

    return Object.entries(localFilters).map(([filterKey, { name, values }]) => {
      return values.map((value) => {
        let displayName = `${name}: `;
        const foundOption = _.get(filters[filterKey], "allOptions", []).find(
          ({ value: optionValue }: any) => value === optionValue
        );
        if (foundOption) {
          displayName += `${foundOption.name}`;
        }
        return (
          <Chip
            key={value}
            label={displayName}
            onDelete={() =>
              this.applyLocalFilter(filterKey as FilterKeys, value)
            }
            className={classNames(classes.filterChip, classes.greyTextColor)}
          />
        );
      });
    });
    // return ();

    // return isfilterApplied ? (
    //   <div>{}</div>
    // ) : showEmptyFilter ? (
    //   ""
    // ) : (
    //   ""
    // );
  }
  renderRightFilters = () => {
    const { filters, classes } = this.props;
    const { filters: localFilters, currentlyActiveFilter } = this.state;
    if (!currentlyActiveFilter) {
      return null;
    }
    let options = _.get(filters[currentlyActiveFilter], "allOptions", []);
    let filterKey = currentlyActiveFilter;
    if (currentlyActiveFilter === "courseType") {
      // if courseType is selected then show years as right filters
      options = _.get(filters, "year.allOptions", []);
      filterKey = FilterKeys.year;
    }
    return (
      <div>
        <Typography variant="h6" className={classes.subFilterHeading}>
          {localFilters[filterKey].name}
        </Typography>
        <Grid container spacing={16} wrap="wrap">
          {options.map((data: any) => {
            const isChecked = localFilters[filterKey].values.includes(
              data.value
            );

            return (
              <Grid item xs={4}>
                <FormControlLabel
                  label={data.name}
                  classes={{
                    root: classes.formControlLabelRoot,
                  }}
                  control={
                    <Checkbox
                      color="primary"
                      value={data.value}
                      classes={{
                        root: classes.checkBoxElement,
                        checked: classes.checkedCheckbox,
                      }}
                      checked={isChecked}
                      onClick={() =>
                        this.applyLocalFilter(filterKey, data.value)
                      }
                    />
                  }
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  };

  render() {
    const { classes, filters } = this.props;
    const { filters: localFilters, currentlyActiveFilter } = this.state;

    const courseTypeOptions = _.get(filters.courseType, "allOptions", "");

    return (
      <CardContent>
        <div className={classes.modalHeader}>
          <Typography
            variant="h6"
            component="body1"
            className={classes.textStyleSM}
            align="left"
          >
            Applied Filters
          </Typography>
          <PerfectScrollbar className={classes.scrollbarContainer}>
            <div className={classes.modalFilterChip}>
              {this.renderFilterChip(true)}
            </div>
          </PerfectScrollbar>
        </div>
        <Divider />
        <Grid container>
          <Grid item xs={4}>
            <div>
              <ExpansionPanel
                elevation={0}
                defaultExpanded={true}
                classes={{ expanded: classes.expansionPanelExpanded }}
                onClick={this.setFilterAsActive(FilterKeys.courseType)}
              >
                <ExpansionPanelSummary
                  classes={{
                    root: classes.root,
                    expanded: classes.expansionPanelSummaryExpanded,
                    content: classes.expansionPanelSummaryContent,
                  }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>
                    <span className={classNames(classes.filterTitle)}>
                      Target Exam
                    </span>
                  </Typography>

                  <span>
                    <button
                      className={cx(classes.clearAllBtn)}
                      onClick={this.clearTargetExam}
                    >
                      Clear All
                    </button>
                  </span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                  classes={{ root: classes.expansionPanelDetails }}
                >
                  {courseTypeOptions.map((data: any) => {
                    const isChecked = localFilters.courseType.values.includes(
                      data.value
                    );

                    return (
                      <FormControlLabel
                        label={data.name}
                        classes={{
                          root: classes.formControlLabelRoot,
                        }}
                        control={
                          <Checkbox
                            color="primary"
                            value={data.value}
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                            }}
                            checked={isChecked}
                            onClick={() =>
                              this.applyLocalFilter(
                                FilterKeys.courseType,
                                data.value
                              )
                            }
                          />
                        }
                      />
                    );
                  })}
                </ExpansionPanelDetails>
                {/* <Grid>
                    <div
                      id="side-panel-filter"
                      className={`${classes.sidePanelWrapper}`}
                    >
                      <Grid
                        container
                        id="filterWrapper"
                        alignContent="flex-start"
                      >
                        <Grid item xs={12} className={cx(classes.filtersBox)}>
                          <div>
                            <ExpansionPanel
                              elevation={0}
                              classes={{
                                expanded: classes.expansionPanelExpanded,
                              }}
                              className={classes.expansionPanelRoot}
                              expanded={false}
                            >
                              <ExpansionPanelSummary
                                classes={{
                                  root: classes.expansionPanelSummaryRoot,
                                  content: classes.expansionPanelSummaryContent,
                                  expanded:
                                    classes.expansionPanelSummaryExpanded,
                                }}
                              />
                            </ExpansionPanel>
                          </div>
                          <Grid>
                            <Button>Status</Button>
                          </Grid>
                          <Button>Class</Button>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid> */}
              </ExpansionPanel>
            </div>
            <div
              onClick={this.setFilterAsActive(FilterKeys.status)}
              className={classNames(
                currentlyActiveFilter === "status" && classes.activeFilter,
                classes.subFilter
              )}
            >
              STATUS
            </div>
            <div
              onClick={this.setFilterAsActive(FilterKeys.classes)}
              className={classNames(
                currentlyActiveFilter === "classes" && classes.activeFilter,
                classes.subFilter
              )}
            >
              CLASS
            </div>
          </Grid>
          <Grid item xs={8}>
            <Card elevation={0}>
              <CardContent className={classes.categoryCardContent}>
                <PerfectScrollbar>
                  {!currentlyActiveFilter ? (
                    <div className={classes.noContentContainer}>
                      <img
                        alt="no content"
                        src="/assets/img/mylibrary/no-content.png"
                      />
                      <Typography
                        variant="h6"
                        className={classes.marginTop2x}
                        gutterBottom
                      >
                        Nothing to display
                      </Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        gutterBottom
                      >
                        Select any category from left panel
                      </Typography>
                    </div>
                  ) : (
                    this.renderRightFilters()
                  )}
                </PerfectScrollbar>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
        </Grid>
        <CardActions className={classes.categoryCardAction}>
          <Button
            variant="contained"
            onClick={this.onReset}
            className={classes.clearBtn}
          >
            Clear All
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onApply}
            className={classes.applyBtn}
          >
            Apply
          </Button>
        </CardActions>
      </CardContent>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(ContentFilter);
